import { ReactElement } from 'react';
import ApplicationReasons from '@components/FVSPage/ApplicationReasons';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';

function FVSStep13(): ReactElement {
  return (
    <>
      <ApplicationReasons displayObject={fvsInfoDisplayObject} currentStepNo="step13" />
    </>
  );
}

export default FVSStep13;
